import { render, staticRenderFns } from "./EduCaozuoButton.vue?vue&type=template&id=b8109650&scoped=true"
import script from "./EduCaozuoButton.vue?vue&type=script&lang=js"
export * from "./EduCaozuoButton.vue?vue&type=script&lang=js"
import style0 from "./EduCaozuoButton.vue?vue&type=style&index=0&id=b8109650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8109650",
  null
  
)

export default component.exports